import script from "./accountProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./accountProfile.vue?vue&type=script&setup=true&lang=js"

import "./accountProfile.vue?vue&type=style&index=0&id=8d751672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d751672"]])

export default __exports__